var modules_640a77b2 = {"container":"_1lsxoft","calendar-wrapper":"_9bpnrk"};
import "../../../assets/Drks0YO_.css";

export { modules_640a77b2 as default };
//# sourceMappingURL=DateInput.module.less.js.map
